import {React,useEffect,useState,useContext} from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import {API_URL}  from '../../../Constant';
import {validateASIReportsRoleDIS} from "../../../Custom/Custom";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import {generateExcelASI} from '../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel'
import {GetASIPendencyReportDistrictPDF} from '../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportPdf';
import asiTitle from '../../../asi.json';


function GetASIPendencyReportDistrict() {

  const currentDate = new Date();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();
  const [year,setYear]=useState([]);
  const [surveyYear,setSurveyYear]=useState([]);
  const [division,setdivision]=useState([]);
  const [district,setdistrict]=useState([]);
  const [monthName,setMonthName]=useState(prevMonthName);
  const [divisionList,setDivisionList]=useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState('');
  const [asiPendencyReportForDistrict, setasiPendencyReportForDistrict] = useState([]);
  const [surveyYearRang,setYearNameNext]=useState([]);
  const [yearNameNextTitle,setYearNameNextTitle]=useState([]);
  const [districtName,setdistrictName]=useState([]);
  const [divisionName,setdivisionName]=useState([]);

  const token=useContext(MyContextProvider).token;
  const navigate = useNavigate();

  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
    };


    const userLevel = jwtDecode(token).id.USER_TYPE;
    const userlevelLogin = jwtDecode(token).id.USER_LEVEL_LOCATION;
    const userlevelLoginName = jwtDecode(token).id.LOCATION_NAME;
    const storedLanguage = localStorage.getItem('language');

useEffect(() => { //Get all Years Data


    const userRole = async () => {
      showLoading(true)
      try {
        const role = await validateASIReportsRoleDIS(jwtDecode(token));
        if (!role) {
          alert("You are not an authorized for ASI Report");
          navigate("/dashboard");
        } 
      } catch (error) {
        console.log(error);
      }finally {
        showLoading(false)
      }
    }


  

   
         // All Division  list
      const fetchDivisionList = async () => {
        try {
           const response = await axios.get(`${API_URL}api/getalldivisionallist`, config);
           const allDivision = response.data;
  
          if (allDivision.status) {
            setDivisionList(allDivision.data);
         
          }
        } catch (error) {
          console.error(error);
         }finally {
          showLoading(false)
        }
      };
      if (userLevel === "HEAD QUARTER") {
        fetchDivisionList();
      }
      userRole();

      getSurveyYears();

}, []);


const getSurveyYears=async()=>{
  showLoading(true)
     try {
        const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
        const allYear = response.data;
        if (allYear.status) {
            setYear(allYear.data.surveyYearList.reverse())
            showLoading(false);
        }
  } catch (error) {
     console.error(error);
     showLoading(false);
  }finally{
     showLoading(false);
  }

}


  

const [yearName, setYearName] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault(); 

    
    if (!yearName) {
      toast.error('Please Select Survey Year', messages.COLOR_RED);
      return;
    }

    let modifiedDivision = division;
    let modifiedDistrict = district;


    if (Array.isArray(division) && division.length === 0) {
      modifiedDivision = "";
    }
    if (Array.isArray(district) && district.length === 0) {
      modifiedDistrict = "";
    }

    if(modifiedDivision === "00" || modifiedDistrict ==="00"){
      toast.info('Data not found.', messages.COLOR_RED);
      return false;
    }

    
    const post_data = {
      "survey_year": yearName,
      "division_code": modifiedDivision,
      "district_code": modifiedDistrict
    };

    try {

      showLoading(true);

      const response = await axios.post(`${API_URL}api/asi/reports/asiPendencyReportForDistrict`, post_data, config);


      const pendencyData = response.data;

      if (pendencyData.status) {
        // API now provides Submitted By District keys; normalize for UI/exports
        const normalized = {
          ...pendencyData.data,
          results: Array.isArray(pendencyData?.data?.results)
            ? pendencyData.data.results.map((item) => ({
                ...item,
                submittedByDistrictDSLCount:
                  item?.submittedByDistrictDSLCount ?? item?.savedDistrictDSLCount ?? '',
                submittedByDistrictDsl:
                  item?.submittedByDistrictDsl ?? item?.savedByDistrictDsl ?? [],
              }))
            : [],
        };
        setasiPendencyReportForDistrict(normalized);
        showLoading(false);
      }
    } catch (error) {
      console.error(error);
      showLoading(false);
    }


  };

  const handleYearChange = (event) => {
     setYearName(event.target.value);
     const selectedYear = parseInt(event.target.value);
      if (!isNaN(selectedYear)) {
        const nextYear = selectedYear + 1;
        setYearNameNext(`${selectedYear}_${nextYear}`);
        setYearNameNextTitle(`${selectedYear}-${nextYear}`);
      }
      
  };

  const handleDistrictChange = (event) => {
      setdistrict(event.target.value);
      const _selectedTextDis = event.target.options[event.target.selectedIndex].text;
      const _districtName = _selectedTextDis === "ALL" ? "" : _selectedTextDis;
      setdistrictName(_districtName);
  };
  
  const handleDivisionChange = async (event) => {
    const selectedDivision = event.target.value;
    setdivision(selectedDivision);
    if (userLevel !== "DIVISION LEVEL") {
      const _selectedText = event.target.options[event.target.selectedIndex].text;
      const _divisionName = _selectedText === "ALL" ? "" : _selectedText;
      setdivisionName(_divisionName);
    }
    if (selectedDivision) {
        // If division is selected, call the API immediately
        showLoading(true);
        const post_data = {
            division_Id: selectedDivision
        };
        try {
            const response = await axios.post(`${API_URL}api/geDistrictListByDivisionId`, post_data, config);
            const allDistricts = response.data;
            if (allDistricts.status) {
                setDistrictList(allDistricts.data);
                showLoading(false);
            }
        } catch (error) {
            console.error(error);
        }
    } else {
    
        setDistrictList([]);
    }
};

useEffect(() => {
    if (userLevel === "DIVISION LEVEL") {
        handleDivisionChange({ target: { value: userlevelLogin } });
        setdivisionName(userlevelLoginName);
    }
}, [division]);


const currentDateTimeShow = new Date().toLocaleString("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "2-digit",
  month: "long",
  year: "numeric"
});


  //Generate Excel *************
const handleGenerateExcel = async () => {
  
  if (!yearName) {
    toast.error('Please Select Survey Year', messages.COLOR_RED);
    return;
  }
  
  if (!asiPendencyReportForDistrict || !asiPendencyReportForDistrict.results || !asiPendencyReportForDistrict.results.length) {
    toast.error('First, search the data, then export as excel', messages.COLOR_RED);
    return;
  }


 
  
 let excelFileName = generateFileName("ASI_PendencyReport")

 const excelObjectData = {
    fileName: excelFileName,
    reportType: excelFileName,
    fileType: 'xls',
    sheetName: excelFileName,
    firstRowMergeCells: "A1:S1",
    firstRowExportDate: 'ASI, Uttar Pradesh (Pendency Report) District',
    firstRowCellNumber: 19,
    secondRowMergeCells: "A2:S2",
    secondRowText: `Survey Year: ${yearNameNextTitle}  ${currentDateTimeShow}`,
    secondRowExportDate: "",// not require
    secondRowCellNumber: 19,// not require
    headerEnglishColumns: [
      'Division Name', 'District Name','Allotted DSL', 'Pending', 'Pending DSL','Saved By Factory', 'Saved By Factory DSL', 'Submitted By District','Submitted By District DSL', 'Rejected By District','Rejected By District DSL','Rejected By Mandal','Rejected By Mandal DSL','Submitted By Mandal','Submitted By Mandal','Accepted By HQ','Accepted HQ DSL','Rejected HQ','Rejected HQ DSL'], headerHindiColumns: []
 };

 const transformedData = asiPendencyReportForDistrict.results.map(item => [
  `${item.divisionName} (${item.divisionCode})`,
  `${item.districtName} (${item.districtCode})`,
    item.allottedDSL,
    item.pending,
    `[${item.pendingDSL}]`,
    item.savedFactoryDSLCount,
    item.savedByFactoryDsl,
    item.submittedByDistrictDSLCount,
    item.submittedByDistrictDsl,
    item.rejectedByDistrictDSLCount,
    item.rejectedByDistrictDsl,
    item.rejectedByMandalDSLCount,
    item.rejectByMandalDsl,
    item.submittedBymandalDSLCount,
    item.submittedByMandalDsl,
    item.acceptedByHqDSLCount,
    item.acceptedByHqDsl,
    item.rejectedByHqDSLCount,
    item.rejectedByHqDsl
  ]);

  excelObjectData.excelRowData = transformedData;
  generateExcelASI(excelObjectData)

}


  //Generate Pdf *************
const handleGeneratePdf = async () => {

  if (!yearName) {
    toast.error('Please Select Survey Year', messages.COLOR_RED);
    return;
  }

  if (!asiPendencyReportForDistrict || !asiPendencyReportForDistrict.results || !asiPendencyReportForDistrict.results.length) {
    toast.error('First, search the data, then export as pdf', messages.COLOR_RED);
    return;
  }


  const heading1 = "ASI, Uttar Pradesh";
  const heading2 = "(Pendency Report) District";
  const heading3 = `Survey Year ${yearNameNextTitle}  ${currentDateTimeShow}`;

  const headerEnglishColumns = [
    'Division Name', 'District Name','Allotted DSL', 'Pending', 'Pending DSL','Saved By Factory', 'Saved By Factory DSL', 'Submitted By District','Submitted By District DSL', 'Rejected By District','Rejected By District DSL','Rejected By Mandal','Rejected By Mandal DSL','Submitted By Mandal','Submitted By Mandal','Accepted By HQ','Accepted HQ DSL','Rejected HQ','Rejected HQ DSL'
  ];

  const pdfData = asiPendencyReportForDistrict.results.map(item => [
    `${item.divisionName} (${item.divisionCode})`,
    `${item.districtName} (${item.districtCode})`,
    item.allottedDSL,
    item.pending,
    `[${item.pendingDSL.join(', ')}]`,
    item.savedFactoryDSLCount,
    `[${item.savedByFactoryDsl.join(', ')}]`,
    item.submittedByDistrictDSLCount,
    `[${(item.submittedByDistrictDsl || []).join(', ')}]`,
    item.rejectedByDistrictDSLCount,
    `[${item.rejectedByDistrictDsl.join(', ')}]`,
    item.rejectedByMandalDSLCount,
    `[${item.rejectByMandalDsl.join(', ')}]`,
    item.submittedBymandalDSLCount,
    `[${item.submittedByMandalDsl.join(', ')}]`,
    item.acceptedByHqDSLCount,
    `[${item.acceptedByHqDsl.join(', ')}]`,
    item.rejectedByHqDSLCount,
    `[${item.rejectedByHqDsl.join(', ')}]`
  ]);


  // const totalDSL = asiPendencyReportForDistrict.filteredData.reduce((acc, item) => acc + item.totalDSL, 0);
  // const totalPendingDSL = asiPendencyReportForDistrict.filteredData.reduce((acc, item) => acc + item.PendingDSL, 0);

  // pdfData.push(["TOTAL", "", totalDSL, totalPendingDSL]);



  // Retrieve divisionName, districtName, monthName, yearName
  // const divisionName = pdfData.length > 0 ? pdfData[0][0] : 'UnknownDivision';
  // const districtName = pdfData.length > 0 ? pdfData[0][1] : 'UnknownDistrict';
  // const monthName = monthNameNextTitle || 'UnknownMonth';
  // const yearName = yearNameNextTitle || 'UnknownYear';

  // const PDFFileName = `ASI_PendencyReport_${divisionName}_${districtName}_${yearName}`;
  const PDFFileName = generateFileName("ASI_PendencyReport")

  const pdfObjectData = {
    heading1,
    heading2,
    heading3,
    headerEnglishColumns,
    pdfData,
    width: [100, 100, 60, 60,80, 60, 60, 60, 60,60, 60, 60, 60, 80,80,80,100,60,100],
    PDFFileName
  };

  GetASIPendencyReportDistrictPDF(pdfObjectData);
};


//Create File name 
const generateFileName= (excelFileName)=>{

  if (typeof divisionName === "string" && divisionName !== "") {
    excelFileName = `${excelFileName}_${divisionName.replace(" ", "_")}`;
  }
  if (typeof districtName === "string" && districtName !=="") {
    excelFileName = `${excelFileName}_${districtName.replace(" ", "_")}`;
  }
  if (typeof yearName === "string" && yearName !=="") {
    excelFileName = `${excelFileName}_${surveyYearRang.replace(" ", "_")}`;
  }
 return excelFileName

}


  return (
    <>
    <ToastContainer />
    <GlobalLoading />

 <div className="container-fluid py-3">
     <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
           <h4 className="page_heading">
            
           <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.ASI_Pendency_Report_District : asiTitle.en.ASI_Pendency_Report_District }} />
            
            </h4>

           <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}</label>
                <select value={yearName} onChange={handleYearChange} name="surveyYear"  className="form-select">
                  <option value="">Select Year</option>
                  {year
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => (
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                  ))}
              </select>
            </div>

            {userLevel === "HEAD QUARTER" && (
              <>
                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? asiTitle.hi.DIVISION : asiTitle.en.DIVISION}</label>
                
                <select value={division} onChange={handleDivisionChange} name="division" className="form-select">
                  <option value="">ALL</option>
                  { divisionList.length > 0 && divisionList.map((ele,i)=>(
                    <option key={ele.DIVISION_NAME} value={ele.DIVISION_CODE}>
                      {ele.DIVISION_NAME}
                    </option>
                  ))}
                </select>
                
            </div>
            
            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>{storedLanguage === 'hi' ? asiTitle.hi.DISTRICT : asiTitle.en.DISTRICT}</label>
                <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                  <option value="">ALL</option>
                  {districtList.map((ele, i) => (
                  <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                    {ele.DISTRICT_NAME}
                  </option>
                ))}
                </select>
            </div>
              </>
            )}
            {userLevel === "DIVISION LEVEL" && (
              <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
              <label>{storedLanguage === 'hi' ? asiTitle.hi.DISTRICT : asiTitle.en.DISTRICT}</label>
              <select value={district} onChange={handleDistrictChange} name="district" className="form-select">
                <option value="">ALL</option>
                {districtList.map((ele, i) => (
                <option key={ele.DISTRICT_CODE} value={ele.DISTRICT_CODE}>
                  {ele.DISTRICT_NAME}
                </option>
              ))}
              </select>
          </div>
            )}

            
         
         <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
             <label className="w-100 d-none d-sm-block">&nbsp;</label>
             <button onClick={handleSubmit} type="submit" className="btn btn_orange">Search</button>
         </div>


         <div className="col-xl-4 col-lg-12 mb-3 text-end">
          <label className="w-100 d-none d-sm-block">&nbsp;</label>
              <a href="javascript:void(0);" onClick={handleGenerateExcel} className="btn btn_green px-3 ms-auto"><img src="assets/images/excel.svg" className="me-2"/>Excel</a>
              <a href="#!" onClick={handleGeneratePdf} className="btn btn_green ms-1 px-3"><img src="assets/images/pdf.svg" className="me-2"/>PDF</a>
         </div>             


        </div>
      </div> 
     </div>
     {asiPendencyReportForDistrict.results && asiPendencyReportForDistrict.results.length > 0 && (
    <div className="card mx-3 mb-3">
        <div className="card-body">
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Sr. No</th>
                            <th>Division Name</th>
                            <th>District Name</th>
                            <th>Allotted DSL</th>
                            <th>Pending</th>
                            <th>Pending DSL</th>
                            <th>Saved By Factory</th>
                            <th>Saved By Factory DSL</th>
                            <th>Submitted By District	</th>
                            <th>Submitted By District DSL</th>
                            <th>Rejected By District</th>
                            <th>Rejected By District DSL</th>
                            <th>Rejected By Mandal</th>
                            <th>Rejected By Mandal DSL</th>
                            <th>Submitted By Mandal</th>
                            <th>Submitted By Mandal DSL</th>
                            <th>Accepted By HQ</th>
                            <th>Accepted HQ DSL</th>
                            <th>Rejected HQ</th>
                            <th>Rejected HQ DSL</th>
                        </tr>
                    </thead>
                   
                    <tbody id="subTody">
                        {asiPendencyReportForDistrict.results
                            .filter(item => {
                                for (const key in item) {
                                    if (item.hasOwnProperty(key)) {
                                        if (key === "savedByFactoryDsl" || key === "submittedByDistrictDsl" || key === "rejectedByDistrictDsl" || key === "rejectByMandalDsl" || key ==="submittedByMandalDsl" || key === "acceptedByHqDsl") {
                                            if (item[key] && Array.isArray(item[key])) {
                                                item[key] = item[key].map(value => parseInt(value));
                                            }
                                        }
                                    }
                                }
                                return item && (item.divisionName || item.divisionCode || item.districtName || item.allottedDSL || item.savedByFactoryDsl || item.submittedByDistrictDSLCount || item.savedFactoryDSLCount || item.submittedByDistrictDsl ||  item.rejectedByDistrictDSLCount || item.rejectedByDistrictDsl || item.rejectedByMandalDSLCount || item.rejectByMandalDsl || item.submittedBymandalDSLCount || item.submittedByMandalDsl || item.acceptedByHqDSLCount || item.acceptedByHqDsl);
                            })
                            .map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item && item.divisionName ? `${item.divisionName} (${item.divisionCode})` : ""}</td>
                                    <td>{item && item.districtName ? `${item.districtName} (${item.districtCode})` : ""}</td>
                                    <td>{item && parseInt(item.allottedDSL) !== null ? parseInt(item.allottedDSL) : ""}</td>
                                    <td>{item && parseInt(item.pending) !== null ? parseInt(item.pending) : ""}</td>
                                    <td>{item && item.pendingDSL ? `[ ${item.pendingDSL.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.savedFactoryDSLCount) !== null ? parseInt(item.savedFactoryDSLCount) : ""}</td>
                                    <td>{item && item.savedByFactoryDsl ? `[ ${item.savedByFactoryDsl.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.submittedByDistrictDSLCount) !== null ? parseInt(item.submittedByDistrictDSLCount) : ""}</td>
                                    <td>{item && item.submittedByDistrictDsl ? `[ ${item.submittedByDistrictDsl.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.rejectedByDistrictDSLCount) !== null ? parseInt(item.rejectedByDistrictDSLCount) : ""}</td>
                                    <td>{item && item.rejectedByDistrictDsl ? `[ ${item.rejectedByDistrictDsl.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.rejectedByMandalDSLCount) !== null ? parseInt(item.rejectedByMandalDSLCount) : ""}</td>
                                    <td>{item && item.rejectByMandalDsl ? `[ ${item.rejectByMandalDsl.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.submittedBymandalDSLCount) !== null ? parseInt(item.submittedBymandalDSLCount) : ""}</td>
                                    <td>{item && item.submittedByMandalDsl ? `[ ${item.submittedByMandalDsl.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.acceptedByHqDSLCount) !== null ? parseInt(item.acceptedByHqDSLCount) : ""}</td>
                                    <td>{item && item.acceptedByHqDsl ? `[ ${item.acceptedByHqDsl.join(', ')} ]` : ""}</td>
                                    <td>{item && parseInt(item.rejectedByHqDSLCount) !== null ? parseInt(item.rejectedByHqDSLCount) : ""}</td>
                                    <td>{item && item.rejectedByHqDsl ? `[ ${item.rejectedByHqDsl.join(', ')} ]` : ""}</td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
)}
    
</div>
 
 </>
  )
}

export default GetASIPendencyReportDistrict